
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"301","height":"104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.066 29.04L7 67.829l.671 17.98 11.118 3.86 14.104-17.364 13.134-30.968m15.561 8.067L55.855 82.48l1.638 13.714L91.891 97M64.045 76.025l26.208-2.42m-24.57-19.361h16.38l13.923-2.42m48.32 0l-21.294-4.034-14.741 1.613v20.168l32.759 4.034 5.733 12.908L124.65 97l-18.836-10.487m89.27-50.824l-24.57 1.614-12.285 8.873 2.457 12.101 34.398-1.613 9.828 16.941-16.38 5.647-28.665-.807m45.045-56.47l9.008 29.849 13.923 17.747 31.121-9.68m-39.311-15.328l27.027-3.227m-37.674-19.361l40.131-2.42M258.964 1l3.276 34.69 8.19 22.587h21.294L295 41.337","stroke":"#000","stroke-width":"12"}})])
          )
        }
      }
    